import React, {createContext, useEffect, useState} from "react"
import moment from "moment"
import UseDebounce from "../../shared/UseDebounce"
import {detailCustomersList} from "../../../services/api/apListCustomers"

export const Context = createContext({})

export const Provider = (props) => {
    const {params = {}, listCusID} = props
    let newParams = {...params}
    if (params.createDateFrom !== undefined) newParams = {...newParams, createDateFrom: moment(params.createDateFrom)}
    if (params.createDateTo !== undefined) newParams = {...newParams, createDateTo: moment(params.createDateTo)}
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(50)
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [detailListCustomers, setDetailListCustomers] = useState('')
    const [filters, setFilters] = useState({
        ...newParams
    })

    const debouncedName = UseDebounce(filters.name, 500)
    const debouncedPhone = UseDebounce(filters.phone, 500)

    const _fetchDetailListCustomers = async () => {
        setLoading(true)
        setError('')

        try {
            const payload = {
                ...filters,
                limit,
                page,
                customerListId: listCusID
            }

            const response = await detailCustomersList(payload)

            const {success, data, error_message, totalRecord} = response

            if (parseInt(success) !== 1) {
                setLoading(false)
                return setError(error_message)
            }

            setLoading(false)
            setDetailListCustomers(data)
            setTotal(totalRecord)
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    const _setFiltersState = (params) => {
        setFilters({
            ...filters,
            ...params
        })
    }

    useEffect(() => {
        _fetchDetailListCustomers()
        // eslint-disable-next-line
    }, [debouncedName, debouncedPhone, page, limit])

    return (
        <Context.Provider
            value={{
                listCusID,
                detailListCustomers,
                filters,
                total,
                page,
                limit,
                loading,
                error,
                setPage,
                setLimit,
                fetchDetailListCustomers: _fetchDetailListCustomers,
                setFiltersState: _setFiltersState
            }}
        >
            {props.children}
        </Context.Provider>
    )
}

export {
    Context as CustomerManagerContext,
    Provider as CustomerManagerContextProvider,
} from "./CustomerManagerContext"
